const UrgentUnprocessedRouter = {
    path: "urgentUnprocessed",
    name: "urgentUnprocessed",
    meta: {
        title: "紧急@待处理"
    },
    component: () =>
        import("@/pages/index/home/urgentUnprocessed/UrgentUnprocessed"),
    redirect: {
        name: "my-UrgentUnprocessed"
    },
    children: [
        {
            path: "my-UrgentUnprocessed",
            name: "my-UrgentUnprocessed",
            meta: {
                title: "紧急@待处理-列表页"
            },
            component: () => import("@/pages/index/home/urgentUnprocessed/List")
        },
        {
            path: "all-UrgentUnprocessed",
            name: "all-UrgentUnprocessed",
            meta: {
                title: "紧急@待处理-列表页"
            },
            component: () => import("@/pages/index/home/urgentUnprocessed/List")
        }
    ]
};
export default UrgentUnprocessedRouter;



// WEBPACK FOOTER //
// ./src/router/index/home/urgentUnprocessed.js